export const buildSubHeading = (products) => {
  if (!products?.length) return '';
  return products.map((product) => `${product.quantity} x ${product.name}`).join(' + ');
};

// Cart/order lines carry no explicit bundle flag (no item_type/product_type), and BE has already
// renamed the product title format once (from "Bundle <Category> <n>" to "<Category> Credits
// Bundles <n>" / "Refresh Credits <n>") — match loosely on both formats instead of a strict prefix
// so the next BE wording tweak doesn't silently break detection again.
// Word-boundary matched (not a plain substring test) — "hot" as a bare substring also matches
// inside unrelated titles like "Verified Photography Credits", misclassifying them as bundles.
const BUNDLE_CATEGORY_KEYWORD_PATTERNS = ['super hot', 'hot', 'refresh'].map(
  (keyword) => new RegExp(`\\b${keyword}\\b`),
);

export const isBundleProductTitle = (title) => {
  if (!title) return false;
  const lower = title.toLowerCase();
  if (lower.startsWith('bundle ')) return true;
  return lower.includes('credit') && BUNDLE_CATEGORY_KEYWORD_PATTERNS.some((pattern) => pattern.test(lower));
};

const decorateBundle = (bundle) => {
  const pricePerCredit = bundle?.total_quantity ? Math.round(bundle.price / bundle.total_quantity) : bundle.price;
  const originalTotal =
    bundle?.discount_percentage > 0 ? Math.round(bundle.price / (1 - bundle.discount_percentage / 100)) : null;

  return {
    ...bundle,
    pricePerCredit,
    originalTotal,
    subHeading: buildSubHeading(bundle?.products),
  };
};

const bundlesApis = {
  getBundles: {
    query: () => {
      return { url: '/api/surge/bundles' };
    },
    transformer: (response) => {
      const data = response?.data ?? response;
      return {
        available: !!data?.available,
        zone: data?.zone,
        province: data?.province,
        currency: data?.currency,
        categories:
          data?.categories?.map((category) => ({
            ...category,
            bundles: category?.bundles?.map(decorateBundle) ?? [],
          })) ?? [],
      };
    },
  },
};

export default bundlesApis;
